import React from "react";

export const Mail: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="icon">
      <g fill="#004B96" fill-rule="nonzero">
        <path d="M31.718 5.608l-9.705 9.642 9.705 9.642A2.78 2.78 0 0032 23.688V6.813a2.78 2.78 0 00-.282-1.205zM29.188 4H2.813a2.78 2.78 0 00-1.205.282L14.01 16.623a2.815 2.815 0 003.977 0L30.392 4.282A2.78 2.78 0 0029.188 4zM.282 5.608A2.78 2.78 0 000 6.813v16.875c0 .432.106.838.282 1.204l9.705-9.642L.282 5.608z" />
        <path d="M20.688 16.576l-1.374 1.373a4.692 4.692 0 01-6.628 0l-1.373-1.373-9.705 9.642a2.78 2.78 0 001.204.282h26.375a2.78 2.78 0 001.205-.282l-9.704-9.642z" />
      </g>
    </svg>
  );
};
